(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-slider"] && !Shopify.designMode) return;
  try {
    
  const initializeBrandSliders = (scope = document) => {
    scope.querySelectorAll('[data-brand-slider]:not([data-brand-initialized])').forEach((slider) => {
      slider.dataset.brandInitialized = 'true';
      const viewport = slider.querySelector('[data-brand-viewport]');
      const previous = slider.querySelector('[data-brand-previous]');
      const next = slider.querySelector('[data-brand-next]');
      const autoplay = slider.dataset.autoplay === 'true';
      const speed = Number(slider.dataset.speed) || 4000;
      let timer;

      const move = (direction) => {
        const firstItem = viewport.querySelector('.brand-logo-slider__item');
        if (!firstItem) return;
        const gap = Number.parseFloat(getComputedStyle(viewport.querySelector('.brand-logo-slider__track')).gap) || 0;
        const distance = firstItem.getBoundingClientRect().width + gap;
        const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;

        if (direction > 0 && atEnd) {
          viewport.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direction < 0 && viewport.scrollLeft <= 4) {
          viewport.scrollTo({ left: viewport.scrollWidth, behavior: 'smooth' });
        } else {
          viewport.scrollBy({ left: distance * direction, behavior: 'smooth' });
        }
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (autoplay) timer = window.setInterval(() => move(1), speed);
      };

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      start();
    });
  };

  initializeBrandSliders();
  document.addEventListener('shopify:section:load', (event) => initializeBrandSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-cart-drawer')) {
    class CustomCartDrawer extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-ccd-body]');
        this.items = this.querySelector('[data-ccd-items]');
        this.empty = this.querySelector('[data-ccd-empty]');
        this.filled = this.querySelector('[data-ccd-filled]');
        this.footer = this.querySelector('[data-ccd-footer]');
        this.loading = this.querySelector('[data-ccd-loading]');
        this.panel = this.querySelector('.ccd__panel');
        this.lastFocus = null;
        this.cart = null;
        this.recommendationProductId = null;
        this.bindEvents();
        this.refresh(false);
      }

      bindEvents() {
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-ccd-close]')) this.close();

          const quantityButton = event.target.closest('[data-ccd-quantity]');
          if (quantityButton) {
            const line = Number(quantityButton.dataset.line);
            const quantity = Number(quantityButton.dataset.quantity);
            this.changeLine(line, quantity);
          }

          const removeButton = event.target.closest('[data-ccd-remove]');
          if (removeButton) this.changeLine(Number(removeButton.dataset.line), 0);

          const recommendationButton = event.target.closest('[data-ccd-recommendation-add]');
          if (recommendationButton) this.addVariant(recommendationButton.dataset.variantId, 1);
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
        });

        document.addEventListener('click', (event) => {
          const cartTrigger = event.target.closest([
            'a[href*="/cart"]',
            '[ref="cartButton"]',
            '[data-cart-drawer-trigger]',
            '[data-testid="cart-icon"]',
            '.header-actions__cart-icon',
            '.header-actions__action--cart',
            '.header__icon--cart',
            'button[aria-label*="cart" i]',
            '[role="button"][aria-label*="cart" i]'
          ].join(','));

          if (!cartTrigger || this.contains(cartTrigger)) return;
          if (cartTrigger.matches('a[href*="/checkout"]')) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          this.open();
        }, true);

        document.addEventListener('submit', (event) => {
          const form = event.target.closest('form[action*="/cart/add"]');
          if (!form || this.contains(form)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.addFromForm(form);
        }, true);
      }

      async request(url, options = {}) {
        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json', ...options.headers },
          ...options
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Cart could not be updated.');
        return data;
      }

      async addFromForm(form) {
        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;
        this.open(true);

        try {
          const formData = new FormData(form);
          await this.request(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body: formData });
          await this.refresh(true);
        } catch (error) {
          this.showError(error.message);
          this.loading.hidden = true;
        } finally {
          if (submitButton) submitButton.disabled = false;
        }
      }

      async addVariant(variantId, quantity) {
        if (!variantId) return;
        this.setLoading(true);
        try {
          await this.request(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
          });
          await this.refresh(true);
        } catch (error) {
          this.showError(error.message);
          this.setLoading(false);
        }
      }

      async changeLine(line, quantity) {
        this.setLoading(true);
        try {
          await this.request(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity })
          });
          await this.refresh(true);
        } catch (error) {
          this.showError(error.message);
          this.setLoading(false);
        }
      }

      async refresh(loadRecommendations = true) {
        this.setLoading(true);
        try {
          this.cart = await this.request(`${window.Shopify?.routes?.root || '/'}cart.js`);
          this.renderCart();
          this.updateExternalCount();
          if (loadRecommendations && this.cart.items[0]) this.loadRecommendations(this.cart.items[0].product_id);
        } catch (error) {
          this.showError(error.message);
        } finally {
          this.setLoading(false);
        }
      }

      renderCart() {
        const isEmpty = !this.cart || this.cart.item_count === 0;
        this.empty.hidden = !isEmpty;
        this.filled.hidden = isEmpty;
        this.footer.hidden = isEmpty;
        this.querySelector('[data-ccd-count]').textContent = isEmpty ? '' : `${this.cart.item_count} ${this.cart.item_count === 1 ? 'item' : 'items'}`;
        if (isEmpty) {
          this.items.innerHTML = '';
          return;
        }

        this.items.innerHTML = this.cart.items.map((item, index) => this.itemTemplate(item, index + 1)).join('');
        this.querySelector('[data-ccd-subtotal]').textContent = this.formatMoney(this.cart.total_price);
        this.renderShipping();
      }

      itemTemplate(item, line) {
        const image = item.image || '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? this.escapeHtml(item.variant_title) : '';
        return `
          <article class="ccd__item">
            <a class="ccd__item-image" href="${this.escapeHtml(item.url)}"><img src="${this.escapeHtml(image)}" alt="${this.escapeHtml(item.product_title)}" width="220" height="220" loading="lazy"></a>
            <div>
              <div class="ccd__item-top">
                <a class="ccd__item-title" href="${this.escapeHtml(item.url)}">${this.escapeHtml(item.product_title)}</a>
                <span class="ccd__item-price">${this.formatMoney(item.final_line_price)}</span>
              </div>
              ${variant ? `<p class="ccd__variant">${variant}</p>` : ''}
              <div class="ccd__item-actions">
                <div class="ccd__quantity">
                  <button type="button" data-ccd-quantity data-line="${line}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
                  <input value="${item.quantity}" readonly aria-label="Quantity">
                  <button type="button" data-ccd-quantity data-line="${line}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="ccd__remove" data-ccd-remove data-line="${line}">Remove</button>
              </div>
            </div>
          </article>`;
      }

      renderShipping() {
        const target = Number(this.dataset.shippingTarget || 0);
        const shippingText = this.querySelector('[data-ccd-shipping-text]');
        const progress = this.querySelector('[data-ccd-progress]');
        if (!target) {
          this.querySelector('[data-ccd-shipping]').hidden = true;
          return;
        }
        this.querySelector('[data-ccd-shipping]').hidden = false;
        const remaining = Math.max(0, target - this.cart.total_price);
        const percentage = Math.min(100, (this.cart.total_price / target) * 100);
        progress.style.width = `${percentage}%`;
        shippingText.textContent = remaining === 0
          ? this.dataset.shippingSuccess
          : `${this.dataset.shippingPrefix} ${this.formatMoney(remaining)} ${this.dataset.shippingSuffix}`;
      }

      async loadRecommendations(productId) {
        if (this.dataset.showRecommendations !== 'true' || !productId || this.recommendationProductId === productId) return;
        this.recommendationProductId = productId;
        const container = this.querySelector('[data-ccd-recommendations]');
        const list = this.querySelector('[data-ccd-recommendation-list]');
        try {
          const data = await this.request(`${window.Shopify?.routes?.root || '/'}recommendations/products.json?product_id=${productId}&limit=3&intent=related`);
          const products = (data.products || []).slice(0, 3);
          if (!products.length) return;
          list.innerHTML = products.map((product) => {
            const variant = product.variants.find((entry) => entry.available) || product.variants[0];
            const image = product.featured_image || '';
            return `<article class="ccd__recommendation">
              <a href="${this.escapeHtml(product.url)}"><img src="${this.escapeHtml(image)}" alt="${this.escapeHtml(product.title)}" width="160" height="160" loading="lazy"></a>
              <div><a class="ccd__recommendation-title" href="${this.escapeHtml(product.url)}">${this.escapeHtml(product.title)}</a><div class="ccd__recommendation-price">${this.formatMoney(product.price)}</div></div>
              <button type="button" class="ccd__recommendation-add" data-ccd-recommendation-add data-variant-id="${variant?.id || ''}" ${variant?.available ? '' : 'disabled'}>${this.escapeHtml(this.dataset.addText)}</button>
            </article>`;
          }).join('');
          container.hidden = false;
        } catch (error) {
          container.hidden = true;
        }
      }

      updateExternalCount() {
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"]').forEach((element) => {
          if (!this.contains(element)) element.textContent = this.cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: this.cart } }));
      }

      formatMoney(cents) {
        const currency = this.cart?.currency || window.Shopify?.currency?.active || 'INR';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency }).format(cents / 100);
        } catch (error) {
          return `Rs. ${(cents / 100).toFixed(2)}`;
        }
      }

      escapeHtml(value = '') {
        const element = document.createElement('div');
        element.textContent = String(value);
        return element.innerHTML;
      }

      setLoading(state) { this.loading.hidden = !state; }

      open(showLoading = false) {
        document.querySelectorAll('cart-drawer[open], cart-drawer.is-open, dialog[open]').forEach((drawer) => {
          if (!this.contains(drawer)) {
            drawer.removeAttribute('open');
            drawer.classList.remove('is-open');
          }
        });
        this.lastFocus = document.activeElement;
        this.classList.add('is-open');
        document.body.classList.add('ccd-lock');
        this.setLoading(showLoading);
        requestAnimationFrame(() => this.panel.focus());
        if (!showLoading) this.refresh(true);
      }

      close() {
        this.classList.remove('is-open');
        document.body.classList.remove('ccd-lock');
        if (this.lastFocus?.focus) this.lastFocus.focus();
      }

      showError(message) {
        const toast = this.querySelector('[data-ccd-toast]');
        toast.textContent = message;
        toast.classList.add('is-visible');
        window.setTimeout(() => toast.classList.remove('is-visible'), 3500);
      }
    }

    customElements.define('custom-cart-drawer', CustomCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviewSliders = (scope = document) => {
      const tracks = [];

      if (scope.matches && scope.matches('.customer-reviews__track')) tracks.push(scope);
      if (scope.querySelectorAll) {
        scope.querySelectorAll('.customer-reviews__track:not([data-slider-ready])').forEach((track) => tracks.push(track));
      }

      tracks.forEach((track) => {
        if (track.dataset.sliderReady === 'true') return;
        track.dataset.sliderReady = 'true';

        const section = track.closest('.customer-reviews');
        const cards = [...track.querySelectorAll('.customer-reviews__card')];
        const dots = section ? [...section.querySelectorAll('[data-review-dot]')] : [];
        const prevButton = section?.querySelector('.customer-reviews__arrow--prev');
        const nextButton = section?.querySelector('.customer-reviews__arrow--next');

        if (!cards.length) return;

        let autoplayTimer = null;
        let scrollFrame = null;
        let startX = 0;
        let startScroll = 0;
        let dragging = false;
        let activeIndex = 0;

        const getGap = () => {
          const styles = window.getComputedStyle(track);
          return parseFloat(styles.columnGap || styles.gap || 0) || 0;
        };

        const getStep = () => cards[0].getBoundingClientRect().width + getGap();

        const getMaxIndex = () => {
          const step = getStep();
          if (!step) return 0;
          return Math.max(0, Math.round(track.scrollWidth / step - track.clientWidth / step));
        };

        const getIndexFromScroll = () => {
          const step = getStep();
          if (!step) return 0;
          return Math.min(getMaxIndex(), Math.max(0, Math.round(track.scrollLeft / step)));
        };

        const updateUI = () => {
          activeIndex = getIndexFromScroll();
          const maxIndex = getMaxIndex();

          dots.forEach((dot, index) => {
            dot.hidden = index > maxIndex;
            const active = index === activeIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });

          if (prevButton) prevButton.disabled = activeIndex <= 0;
          if (nextButton) nextButton.disabled = activeIndex >= maxIndex;

          const noOverflow = maxIndex === 0;
          if (prevButton?.parentElement) prevButton.parentElement.hidden = noOverflow;
          const pagination = section?.querySelector('.customer-reviews__pagination');
          if (pagination) pagination.hidden = noOverflow;
        };

        const scrollToIndex = (index, behavior = 'smooth') => {
          const maxIndex = getMaxIndex();
          const targetIndex = Math.min(maxIndex, Math.max(0, index));
          track.scrollTo({ left: targetIndex * getStep(), behavior });
        };

        const stopAutoplay = () => {
          if (autoplayTimer) window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (track.dataset.autoplay !== 'true') return;
          if (cards.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (getMaxIndex() === 0) return;

          const interval = Math.max(2000, Number(track.dataset.interval) || 5000);
          autoplayTimer = window.setInterval(() => {
            const current = getIndexFromScroll();
            const maxIndex = getMaxIndex();
            scrollToIndex(current >= maxIndex ? 0 : current + 1);
          }, interval);
        };

        prevButton?.addEventListener('click', () => {
          scrollToIndex(getIndexFromScroll() - 1);
          startAutoplay();
        });

        nextButton?.addEventListener('click', () => {
          const current = getIndexFromScroll();
          const maxIndex = getMaxIndex();
          scrollToIndex(current >= maxIndex ? 0 : current + 1);
          startAutoplay();
        });

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            scrollToIndex(Number(dot.dataset.reviewDot));
            startAutoplay();
          });
        });

        track.addEventListener('scroll', () => {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(updateUI);
        }, { passive: true });

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch') return;
          dragging = true;
          startX = event.clientX;
          startScroll = track.scrollLeft;
          track.classList.add('is-dragging');
          track.setPointerCapture?.(event.pointerId);
          stopAutoplay();
        });

        track.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          event.preventDefault();
          track.scrollLeft = startScroll - (event.clientX - startX);
        });

        const stopDragging = (event) => {
          if (!dragging) return;
          dragging = false;
          track.classList.remove('is-dragging');
          if (track.hasPointerCapture?.(event.pointerId)) track.releasePointerCapture(event.pointerId);
          scrollToIndex(getIndexFromScroll());
          startAutoplay();
        };

        track.addEventListener('pointerup', stopDragging);
        track.addEventListener('pointercancel', stopDragging);
        track.addEventListener('focusin', stopAutoplay);
        track.addEventListener('focusout', startAutoplay);

        const onResize = () => {
          window.requestAnimationFrame(() => {
            updateUI();
            scrollToIndex(Math.min(activeIndex, getMaxIndex()), 'auto');
            startAutoplay();
          });
        };

        window.addEventListener('resize', onResize);

        updateUI();
        startAutoplay();
      });
    };

    const boot = () => initializeReviewSliders(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => initializeReviewSliders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-reels"] && !Shopify.designMode) return;
  try {
    

const initializeShoppableReels = (scope = document) => {

  scope
    .querySelectorAll(
      '[data-shoppable-reels]:not([data-reels-initialized])'
    )
    .forEach((section) => {

      section.dataset.reelsInitialized = 'true';


      const viewport =
        section.querySelector(
          '[data-reels-viewport]'
        );


      const items =
        Array.from(
          section.querySelectorAll(
            '[data-reel-item]'
          )
        );


      if (!viewport || !items.length) return;


      /* =========================================
         DESKTOP MOUSE DRAG ONLY
         TOUCH / IPHONE = NATIVE SCROLL
      ========================================= */


      let dragging = false;

      let moved = false;

      let startX = 0;

      let startScrollLeft = 0;


      viewport.addEventListener(
        'pointerdown',
        (event) => {

          /*
            IMPORTANT:
            iPhone / iPad / Android touch
            should NOT run custom drag.
          */

          if (event.pointerType !== 'mouse') {
            return;
          }


          if (event.button !== 0) {
            return;
          }


          dragging = true;

          moved = false;

          startX = event.clientX;

          startScrollLeft =
            viewport.scrollLeft;


          viewport.classList.add(
            'is-dragging'
          );

        }
      );


      viewport.addEventListener(
        'pointermove',
        (event) => {

          if (!dragging) return;

          if (event.pointerType !== 'mouse') {
            return;
          }


          const distance =
            event.clientX - startX;


          if (
            Math.abs(distance) > 5
          ) {

            moved = true;

          }


          viewport.scrollLeft =
            startScrollLeft - distance;

        }
      );


      const finishDrag = () => {

        if (!dragging) return;


        dragging = false;


        viewport.classList.remove(
          'is-dragging'
        );


        /*
          delay reset so accidental
          product click after dragging
          does not fire
        */

        window.setTimeout(
          () => {

            moved = false;

          },
          80
        );

      };


      viewport.addEventListener(
        'pointerup',
        finishDrag
      );


      viewport.addEventListener(
        'pointercancel',
        finishDrag
      );


      viewport.addEventListener(
        'pointerleave',
        finishDrag
      );


      /*
        Stop accidental product click
        after desktop drag
      */

      viewport.addEventListener(
        'click',
        (event) => {

          if (!moved) return;


          event.preventDefault();

          event.stopPropagation();

        },
        true
      );


      /* =========================================
         VIDEO PLAY / MUTE
      ========================================= */


      section.addEventListener(
        'click',
        (event) => {

          const playButton =
            event.target.closest(
              '[data-video-play]'
            );


          const muteButton =
            event.target.closest(
              '[data-video-mute]'
            );


          /*
            Ignore normal product clicks
          */

          if (
            !playButton &&
            !muteButton
          ) {

            return;

          }


          const item =
            event.target.closest(
              '[data-reel-item]'
            );


          if (!item) return;


          const video =
            item.querySelector('video');


          if (!video) return;


          /* PLAY / PAUSE */

          if (playButton) {

            if (video.paused) {

              const playPromise =
                video.play();


              if (
                playPromise !== undefined
              ) {

                playPromise
                  .then(() => {

                    playButton.classList.add(
                      'is-playing'
                    );


                    playButton.setAttribute(
                      'aria-label',
                      'Pause video'
                    );

                  })
                  .catch(() => {});

              }

            } else {

              video.pause();


              playButton.classList.remove(
                'is-playing'
              );


              playButton.setAttribute(
                'aria-label',
                'Play video'
              );

            }

          }


          /* MUTE / UNMUTE */

          if (muteButton) {

            video.muted =
              !video.muted;


            muteButton.classList.toggle(
              'is-unmuted',
              !video.muted
            );


            muteButton.setAttribute(
              'aria-label',
              video.muted
                ? 'Unmute video'
                : 'Mute video'
            );

          }

        }
      );


      /* =========================================
         AUTOPLAY VISIBLE VIDEO
      ========================================= */


      if (
        'IntersectionObserver'
        in window
      ) {

        const observer =
          new IntersectionObserver(

            (entries) => {

              entries.forEach(
                (entry) => {

                  const video =
                    entry.target
                      .querySelector(
                        'video'
                      );


                  const playButton =
                    entry.target
                      .querySelector(
                        '[data-video-play]'
                      );


                  if (!video) return;


                  if (
                    entry.isIntersecting
                  ) {

                    /*
                      Autoplay must stay muted
                      for iPhone Safari
                    */

                    video.muted = true;


                    const playPromise =
                      video.play();


                    if (
                      playPromise !== undefined
                    ) {

                      playPromise
                        .then(() => {

                          playButton
                            ?.classList.add(
                              'is-playing'
                            );

                        })
                        .catch(() => {});

                    }

                  } else {

                    video.pause();


                    playButton
                      ?.classList.remove(
                        'is-playing'
                      );

                  }

                }
              );

            },

            {
              root: viewport,

              /*
                Slightly lower threshold
                gives smoother iPhone behavior
              */
              threshold: 0.55
            }

          );


        items.forEach(
          (item) => {

            observer.observe(item);

          }
        );

      }


      /* =========================================
         IOS SAFARI VIDEO ATTRIBUTES
      ========================================= */


      section
        .querySelectorAll('video')
        .forEach((video) => {

          video.setAttribute(
            'playsinline',
            ''
          );


          video.setAttribute(
            'webkit-playsinline',
            ''
          );


          video.playsInline = true;


          /*
            Autoplay-compatible default
          */

          video.muted = true;

        });


    });

};


/* INITIAL LOAD */

if (
  document.readyState ===
  'loading'
) {

  document.addEventListener(
    'DOMContentLoaded',
    () => {

      initializeShoppableReels();

    }
  );

} else {

  initializeShoppableReels();

}


/* SHOPIFY EDITOR */

document.addEventListener(
  'shopify:section:load',
  (event) => {

    initializeShoppableReels(
      event.target
    );

  }
);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-product-collections"] && !Shopify.designMode) return;
  try {
    
  const initializeTabbedCollections = (scope = document) => {
    scope.querySelectorAll('[data-tabbed-collections]:not([data-tabs-initialized])').forEach((section) => {
      section.dataset.tabsInitialized = 'true';
      const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
      const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));

      const activateTab = (tab) => {
        const index = Number(tab.dataset.tabIndex);
        tabs.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          activateTab(tabs[nextIndex]);
        });
      });
    });
  };

  initializeTabbedCollections();
  document.addEventListener('shopify:section:load', (event) => initializeTabbedCollections(event.target));

  } catch(e) { console.error(e); }
})();
})();
